export default __webpack_public_path__ + "static/media/5.4ab4cde8.png";